<div id="sidebar-nav-wrapper">
    <div
        id="sidebar-nav"
        class="text-white d-flex flex-column vh-100"
        [class.expanded]="isExpanded"
        [class.user-section-open]="isUserSectionExpanded"
    >
        <a
            [href]="homeUrlWithProtocol"
            class="home-link d-flex align-items-center justify-content-center text-white text-decoration-none"
        >
            <img
                src="assets/svg/sidebar-nav/tryb-logo.png"
                alt="tryb-logo"
                class="logo"
                *ngIf="isExpanded"
            />
            <img
                src="assets/svg/sidebar-nav/tryb-mini-logo.png"
                alt="tryb-mini-logo"
                class="mini-logo"
                *ngIf="!isExpanded"
            />
        </a>
        <div class="org-context-switch" *ngIf="isInAnyOrg">
            <div class="selector-wrapper">
                <div #collapsedContextIcon *ngIf="!isExpanded">
                    <img
                        class="toggle-label-icon logo collapsed-context-icon"
                        [class.private]="!isInOrgMode"
                        [src]="
                            isInOrgMode
                                ? 'assets/svg/reusable-svg/organization-mode.svg'
                                : 'assets/svg/reusable-svg/private-mode.svg'
                        "
                        [alt]="isInOrgMode ? 'organization-logo' : 'lock-logo'"
                        [title]="
                            (isInOrgMode
                                ? getSelectedOrgName()
                                : 'navigation.sidebarNav.privateMode'
                            ) | translate
                        "
                    />
                </div>
                <select
                    *ngIf="isExpanded"
                    id="active-organization-group-selection"
                    [formControl]="orgControl"
                    (change)="onOrgChange($event)"
                >
                    <option
                        *ngFor="let org of orgs; trackBy: trackOrgById"
                        [value]="org.id"
                        [id]="'organization-' + org.id"
                    >
                        {{
                            org.name === 'navigation.sidebarNav.noOrg'
                                ? (org.name | translate)
                                : org.name
                        }}
                    </option>
                </select>
            </div>
        </div>
        <div class="flex-fill">
            <ul class="nav nav-pills flex-column mb-auto">
                <li
                    class="nav-item"
                    [ngClass]="{ active: activeNavItem === 0 }"
                >
                    <a
                        id="workspace-link"
                        routerLink="/workspace"
                        class="nav-link"
                        [ngClass]="{ selected: activeNavItem === 0 }"
                    >
                        <img
                            src="assets/svg/sidebar-nav/workspace-icon.svg"
                            class="float-start"
                            alt="workspace-icon"
                        />
                        <span class="nav-item-text workspace-link">{{
                            'navigation.sidebarNav.workspace' | translate
                        }}</span>
                    </a>
                </li>
                <li
                    class="nav-item"
                    *ngIf="userRoles.includes('ROLE_USER_MOTORIC_TRAINING')"
                    [ngClass]="{ active: activeNavItem === 1 }"
                >
                    <a
                        class="nav-link"
                        id="motoric-project-link"
                        routerLink="/workspace/motoric"
                        [ngClass]="{ selected: activeNavItem === 1 }"
                    >
                        <img
                            src="assets/svg/sidebar-nav/motoric-icon.svg"
                            class="float-start"
                            alt="motoric-icon"
                        />
                        <span class="nav-item-text motoricp-link">{{
                            'navigation.sidebarNav.motoricProjects' | translate
                        }}</span>
                    </a>
                </li>
                <li
                    class="nav-item"
                    *ngIf="userRoles.includes('ROLE_USER_VISUAL_TRAINING')"
                    [ngClass]="{ active: activeNavItem === 2 }"
                >
                    <a
                        class="nav-link"
                        id="visual-project-link"
                        routerLink="/workspace/visual"
                        [ngClass]="{ selected: activeNavItem === 2 }"
                    >
                        <img
                            src="assets/svg/sidebar-nav/visual-icon.svg"
                            class="float-start"
                            alt="visual-icon"
                        />
                        <span class="nav-item-text visualp-link">{{
                            'navigation.sidebarNav.visualProjects' | translate
                        }}</span>
                    </a>
                </li>
                <li
                    class="nav-item"
                    *ngIf="userRoles.includes('ROLE_USER_VISUAL_TRAINING')"
                    [ngClass]="{ active: activeNavItem === 3 }"
                >
                    <a
                        class="nav-link"
                        id="image-db-link"
                        routerLink="/workspace/imageDb"
                        [ngClass]="{ selected: activeNavItem === 3 }"
                    >
                        <img
                            src="assets/svg/sidebar-nav/picdatabase-icon.svg"
                            class="float-start"
                            alt="picdatabase-icon"
                        />
                        <span class="nav-item-text imagedb-link">{{
                            'navigation.sidebarNav.imageDatabses' | translate
                        }}</span>
                    </a>
                </li>
                <li class="nav-item separation-line ignore-hover-link">
                    <div class="nav-link separation-line-link">
                        <img
                            class="dashed-line"
                            src="assets/svg/sidebar-nav/separating-line-expanded.svg"
                            alt="separating-line-expanded"
                        />
                    </div>
                </li>
                <li
                    class="nav-item"
                    [ngClass]="{ active: activeNavItem === 4 }"
                >
                    <a
                        id="gallery-link"
                        class="nav-link"
                        routerLink="/communityprojects"
                        [ngClass]="{ selected: activeNavItem === 4 }"
                    >
                        <img
                            src="assets/svg/sidebar-nav/gallery-icon.svg"
                            class="float-start"
                            alt="gallery-icon"
                        />
                        <span class="nav-item-text gallery-link">{{
                            'navigation.sidebarNav.gallery' | translate
                        }}</span>
                    </a>
                </li>
            </ul>
        </div>
        <div class="sidebar-expand-controls">
            <ul class="nav nav-pills flex-column mb-auto">
                <li
                    id="sidebar-nav-expand-btn"
                    class="nav-item ignore-hover-link"
                    (click)="onExpand()"
                >
                    <a class="nav-link">
                        <img
                            src="assets/svg/sidebar-nav/arrow-close.svg"
                            class="float-start collapse-button"
                            alt="arrow-close"
                        />
                        <span class="nav-item-text">{{
                            'navigation.sidebarNav.collapse' | translate
                        }}</span>
                    </a>
                </li>
            </ul>
        </div>
        <div
            class="user-section"
            [ngClass]="{ 'user-section-expanded': isUserSectionExpanded }"
        >
            <ul class="nav nav-pills flex-column mb-auto">
                <li class="nav-item user-section-header ignore-hover-link">
                    <a
                        id="user-section-expand-btn"
                        class="nav-link"
                        (click)="onUserSectionExpand()"
                    >
                        <img
                            id="profile-img"
                            [src]="
                                picture
                                    ? picture
                                    : 'assets/svg/sidebar-nav/profile-icon.svg'
                            "
                            alt="profile-picture"
                        />
                        <span class="nav-item-text username-text">{{
                            username
                        }}</span>
                        <img
                            src="assets/svg/sidebar-nav/arrow-up.svg"
                            class="float-start user-section-expand-arrow"
                            alt="arrow-up"
                        />
                    </a>
                    <div
                        class="user-section-options-wrapper"
                        [ngClass]="{
                            expanded: isUserSectionExpanded,
                            admin: isAdmin,
                            'organization-feature': hasOrganizationFeature,
                        }"
                    >
                        <ul class="nav nav-pills flex-column mb-auto">
                            <li
                                class="nav-item no-border-radius"
                                [ngClass]="{
                                    'user-section-active': activeNavItem === 5,
                                }"
                            >
                                <a
                                    id="profile-link"
                                    routerLink="/profile"
                                    class="nav-link"
                                    [ngClass]="{
                                        selected: activeNavItem === 5,
                                    }"
                                >
                                    <img
                                        src="assets/svg/sidebar-nav/profile-icon.png"
                                        alt="profile-icon"
                                    />
                                    <span class="nav-item-text">{{
                                        'navigation.sidebarNav.profile'
                                            | translate
                                    }}</span>
                                </a>
                            </li>
                            <li
                                *ngIf="hasOrganizationFeature"
                                class="nav-item no-border-radius"
                                [ngClass]="{
                                    'user-section-active': activeNavItem === 6,
                                }"
                            >
                                <a
                                    id="organization-area-space-link"
                                    routerLink="/organization"
                                    class="nav-link"
                                    [ngClass]="{
                                        selected: activeNavItem === 6,
                                    }"
                                >
                                    <img
                                        class="white-icon"
                                        src="assets/svg/reusable-svg/organization-mode.svg"
                                        alt="organization-area-icon"
                                    />
                                    <span class="nav-item-text">{{
                                        'navigation.sidebarNav.orgArea'
                                            | translate
                                    }}</span>
                                </a>
                            </li>
                            <li
                                class="nav-item no-border-radius"
                                *ngIf="isAdmin"
                                [ngClass]="{
                                    'user-section-active': activeNavItem === 7,
                                }"
                            >
                                <a
                                    id="admin-space-link"
                                    routerLink="/admin"
                                    class="nav-link"
                                    [ngClass]="{
                                        selected: activeNavItem === 7,
                                    }"
                                >
                                    <img
                                        src="assets/svg/sidebar-nav/admin-icon.png"
                                        alt="admin-icon"
                                    />
                                    <span class="nav-item-text">{{
                                        'navigation.sidebarNav.admin'
                                            | translate
                                    }}</span>
                                </a>
                            </li>
                            <li class="nav-item no-border-radius">
                                <div
                                    id="logout-btn"
                                    class="nav-link"
                                    (click)="onLogOut()"
                                >
                                    <img
                                        src="assets/svg/sidebar-nav/log-out-icon.png"
                                        alt="log-out-icon"
                                    />
                                    <span class="nav-item-text">{{
                                        'navigation.sidebarNav.logOut'
                                            | translate
                                    }}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div id="color-stripe" class="vh-100">
        <div class="workspace-color" [class.active]="activeNavItem === 0"></div>
        <div class="motoric-color" [class.active]="activeNavItem === 1"></div>
        <div class="visual-color" [class.active]="activeNavItem === 2"></div>
        <div class="image-db-color" [class.active]="activeNavItem === 3"></div>
        <div class="gallery-color" [class.active]="activeNavItem === 4"></div>
        <div class="profile-color" [class.active]="activeNavItem === 5"></div>
        <div
            class="organization-color"
            [class.active]="activeNavItem === 6"
        ></div>
        <div class="admin-color" [class.active]="activeNavItem === 7"></div>
    </div>
</div>
